module.exports = __webpack_public_path__ + "static/media/logoCpanel.db56b70a.svg";